import { Injectable, Injector } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { catchError, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiService } from './services/api/api-service/api-service';
import { TranslateService } from './services/translate/translate.service';
import { FamilyPortalConfig } from './services/family-portal-config';
import ar from '../assets/i18n/ar.json';
import bn from '../assets/i18n/bn.json';
import es from '../assets/i18n/es.json';
import fr from '../assets/i18n/fr.json';
import ht from '../assets/i18n/ht.json';
import ko from '../assets/i18n/ko.json';
import pl from '../assets/i18n/pl.json';
import ru from '../assets/i18n/ru.json';
import ur from '../assets/i18n/ur.json';
import zhCN from '../assets/i18n/zh-CN.json';

// Bundled statically because esbuild cannot resolve the dynamic require the
// webpack builder previously allowed here (require(`../assets/i18n/${lang}.json`)).
const staticTranslationsByLang: Record<string, Translation> = { ar, bn, es, fr, ht, ko, pl, ru, ur, 'zh-CN': zhCN };

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor (
    private apiService: ApiService,
    private injector: Injector,
    private familyPortalConfig: FamilyPortalConfig,
  ) {}

  getTranslation (lang: string) {
    if (lang === 'en') return of({}); // english is the default language, so we don't need to fetch translations for it
    const staticTranslations = staticTranslationsByLang[lang] ?? {};
    return this.apiService.getTranslations(lang).pipe(
      tap(() => {
        const { DEV_MODE } = this.familyPortalConfig.publicConfig;
        if (DEV_MODE) {
          const translateService = this.injector.get(TranslateService);
          const staticKeys = Object.keys(staticTranslations);
          const standardizedStaticKeys = translateService.standardizeKeys(staticKeys);
          sessionStorage.setItem('standardizedStaticKeys', JSON.stringify(standardizedStaticKeys));
        }
      }),
      map((translations) => Object.assign({}, translations, staticTranslations)),
      catchError(() => of(staticTranslations)),
    );
  }
}
